import React, {useCallback, useEffect, useRef, useState} from "react";
import {ChipInput} from "~/apps/core/ui/ChipInput/ChipInput";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";


export type IconChipInputProps = {
    value?: boolean
    onChange?: (value: boolean) => any
    icon: React.ReactNode
    selectedIcon?: React.ReactNode
    disabled?: boolean
}


const useStyles = makeStyles<PortTheme, IconChipInputProps>(theme => ({
    label: {
        "& .MuiSvgIcon-root": {
            margin: 0,
            fontSize: "18px",
            color: props => {
                if (props.value) {
                    return "inherit";
                }
                return props.disabled ? theme.palette.action.disabled : theme.palette.action.active;
            },
        }
    }
}));


export const IconChipInput = (props: IconChipInputProps) => {
    const classes = useStyles(props);
    const {value: inValue, onChange, icon, selectedIcon, disabled} = props;
    const uncontrolled = typeof inValue == "undefined";
    const [value, setValue] = useState(uncontrolled ? false : inValue);
    const ref = useRef<HTMLDivElement>();

    useEffect(() => {
        setValue(inValue);
    }, [inValue]);

    const handleClick = useCallback(() => {
        ref?.current?.blur();
        if (uncontrolled) {
            setValue(!value);
        }
        onChange && onChange(!value);
    }, [value, uncontrolled, onChange]);

    return (
        <ChipInput
            ref={ref}
            selected={!!value}
            onClick={handleClick}
            disabled={disabled}
            label={value ? selectedIcon || icon : icon}
            color="additionalPrimary"
            classes={classes}
        />
    )
}